<div
  *renderingPermissionDirective="[
    'DeviceMonitoringWriter',
    'DeviceMonitoringReader',
    'DeviceMonitoringAdmin',
  ]"
  class="health lx-body">
  <dcc-page-title title="Status Report"></dcc-page-title>

  <health-query-builder
    [isLoading]="isLoading"
    (search)="queryData($event)"></health-query-builder>

  <div class="health-summary">
    <div class="health-summary__container">
      <div class="health-summary__chart-container">
        <canvas
          baseChart
          [datasets]="healthChartDatasets"
          [labels]="healthChartLabels"
          [legend]="false"
          [options]="healthChartOptions"
          [type]="'bar'"></canvas>
      </div>
      <div class="health-metrics">
        <dcc-billboard
          label="Devices"
          [value]="totalDevices | number"></dcc-billboard>
        <dcc-billboard
          label="Pass"
          value="{{ healthyCount | number }} ({{
            percentageHealthy
          }}%)"></dcc-billboard>
        <dcc-billboard
          label="Fail"
          value="{{ unhealthyCount | number }} ({{
            percentageUnhealthy
          }}%)"></dcc-billboard>
      </div>
    </div>
    <div class="health__actions">
      <dcc-share-link-button
        [disabled]="!isHealthSearched"></dcc-share-link-button>
      <dcc-download-csv-button
        *ngIf="!loadingCsv; else loadingTemplate"
        (download)="downloadCsv()"></dcc-download-csv-button>
      <ng-template #loadingTemplate>
        <div class="spinner-border health__download-spinner"></div>
      </ng-template>
    </div>
  </div>

  <div class="grid-container">
    <div
      #countContainerRef
      class="count-container">
      <div
        *ngFor="let count of counts"
        class="count-overlay"
        [style.left]="count.left"
        [style.width]="count.width">
        {{ count.value }}
      </div>
    </div>
    <ag-grid-angular
      #grid
      class="ag-theme-alpine ag-grid-sticky-header"
      domLayout="autoHeight"
      rowSelection="single"
      style="width: 100%; height: 100%; white-space: normal !important"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [enableCellTextSelection]="true"
      [ensureDomOrder]="true"
      [pagination]="false"
      [suppressRowHoverHighlight]="true"
      [tooltipShowDelay]="tooltipShowDelay"
      (bodyScroll)="syncScroll($event)"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="footer">
    <div class="records-per-page">
      <label>Show</label>
      <input
        class="query-builder__basic__recordsPerPage"
        name="count"
        ngDefaultControl
        type="number"
        [max]="paginationPageMaxSize"
        [(ngModel)]="paginationPageSize" />
      <label>Devices (Max 500)</label>
    </div>
    <div class="paginator-container">
      <simple-paginator
        [pageCount]="pageCount"
        [pageNumber]="pageNumber"
        (clickFirst)="onClickFirstPage($event)"
        (clickNext)="onClickNext($event)"></simple-paginator>
    </div>
  </div>
</div>
